<template>
  <div class="ui modal" ref="modal">
    <div class="ui inverted dimmer">
      <div class="ui text double slow blue loader">{{ $t("loading") }}</div>
    </div>
    <i class="close icon"></i>
    <div class="icon header">
      <i class="user tie icon"></i>
      {{ $t("professor") }}
    </div>
    <div class="image content">
      <div class="ui small image">
        <img src="/images/icons/professor.png" style="width: 100% !important" />
      </div>
      <div class="description" style="width: 100% !important">
        <div class="ui form" ref="form">
          <h4 class="ui dividing header">{{ $t("basic information") }}</h4>
          <div class="fields">
            <div class="four wide field">
              <label>{{ $t("user") }}</label>
              <div class="ui search selection dropdown" ref="users_dropdown">
                <input type="hidden" name="user" />
                <i class="dropdown icon"></i>
                <div class="default text">{{ $t("user") }}</div>
                <div class="scrollhint menu"></div>
              </div>
            </div>
            <div class="three wide field">
              <label for>{{ $t("code") }}</label>
              <input
                type="text"
                name="professor_code"
                v-model="professor.professor_code"
              />
            </div>
            <div class="five wide field">
              <label for>{{ $t("name") }}</label>
              <input type="text" name="name" v-model="professor.name" />
            </div>
            <div class="four wide field">
              <label for>{{ $t("lastname") }}</label>
              <input type="text" name="lastname" v-model="professor.lastname" />
            </div>
          </div>
          <div class="fields">
            <div class="four wide field">
              <label>{{ $t("whatsapp") }}</label>
              <input type="text" name="whatsapp" v-model="professor.whatsapp" />
            </div>
            <div class="four wide field">
              <label>{{ $t("dpi") }}</label>
              <input type="text" name="dpi" v-model="professor.dpi" />
            </div>
            <div class="four wide field">
              <label>{{ $t("birth date") }}</label>
              <input
                type="text"
                name="birthdate"
                v-model="professor.birthdate"
              />
            </div>
            <div class="four wide field">
              <label>{{ $t("birth country") }}</label>
              <input
                type="text"
                name="birth_country"
                v-model="professor.birth_country"
              />
            </div>
          </div>
          <div class="fields">
            <div class="four wide field">
              <label>{{ $t("civil status") }}</label>
              <div
                class="ui search selection dropdown"
                ref="civil_status_dropdown"
              >
                <input type="hidden" name="civil_status" />
                <i class="dropdown icon"></i>
                <div class="default text">{{ $t("select one") }}</div>
                <div class="scrollhint menu">
                  <div class="item" data-value="single">{{ $t("single") }}</div>
                  <div class="item" data-value="married">
                    {{ $t("married") }}
                  </div>
                  <div class="item" data-value="divorced">
                    {{ $t("divorced") }}
                  </div>
                </div>
              </div>
            </div>
            <div class="five wide field">
              <label>{{ $t("email") }}</label>
              <input type="text" name="email" v-model="professor.email" />
            </div>
            <div class="seven wide field">
              <label>{{ $t("home address") }}</label>
              <input
                type="text"
                name="home_address"
                v-model="professor.home_address"
              />
            </div>
          </div>
          <h4 class="ui dividing header">{{ $t("professional info") }}</h4>
          <div class="fields">
            <div class="six wide field">
              <label>{{ $t("profession") }}</label>
              <div
                class="ui search selection dropdown"
                ref="profession_dropdown"
              >
                <input type="hidden" name="profession" />
                <i class="dropdown icon"></i>
                <div class="default text">{{ $t("select one") }}</div>
                <div class="scrollhint menu"></div>
              </div>
            </div>
            <div class="four wide field">
              <label>{{ $t("college number") }}</label>
              <input
                type="text"
                name="college_number"
                v-model="professor.college_number"
              />
            </div>
            <div class="six wide field">
              <label>{{ $t("professional college") }}</label>
              <div
                class="ui search selection dropdown"
                ref="professional_college_dropdown"
              >
                <input type="hidden" name="professional_college" />
                <i class="dropdown icon"></i>
                <div class="default text">{{ $t("select one") }}</div>
                <div class="scrollhint menu"></div>
              </div>
            </div>
          </div>
          <div class="fields">
            <div class="four wide field">
              <label>{{ $t("nit") }}</label>
              <input type="text" name="nit" v-model="professor.nit" />
            </div>
            <div class="six wide field">
              <label>{{ $t("tax regime") }}</label>
              <div
                class="ui search selection dropdown"
                ref="tax_regime_dropdown"
              >
                <input type="hidden" name="tax_regime" />
                <i class="dropdown icon"></i>
                <div class="default text">{{ $t("select one") }}</div>
                <div class="scrollhint menu"></div>
              </div>
            </div>
            <div class="six wide field">
              <label>{{ $t("source branch") }}</label>
              <div
                class="ui search selection dropdown"
                ref="reception_branch_dropdown"
              >
                <input type="hidden" name="reception_branch" />
                <i class="dropdown icon"></i>
                <div class="default text">{{ $t("select one") }}</div>
                <div class="scrollhint menu"></div>
              </div>
            </div>
          </div>
          <div class="field">
            <label>{{ $t("teaching branches") }}</label>
            <div
              class="ui multiple search selection dropdown"
              ref="teaching_branches_dropdown"
            >
              <input type="hidden" name="teaching_branches" />
              <i class="dropdown icon"></i>
              <div class="default text">{{ $t("select one") }}</div>
              <div class="scrollhint menu"></div>
            </div>
          </div>
          <!-- <div class="field">
            <label for>{{ $t("description") }}</label>
            <textarea
              name="description"
              rows="2"
              v-model="professor.setup.description"
            ></textarea>
          </div> -->
          <!-- <div class="ui one item pointing secondary menu" ref="tabs">
            <a class="item active" data-tab="general">
              <i class="info circle icon"></i>
              {{ $t("general information") }}
            </a>
          </div>
          <div class="ui tab segment active" data-tab="general">
            <general
              :professor_in="professor"
              :professor_configuration="professor_configuration"
              ref="general"
            />
          </div> -->
        </div>
      </div>
    </div>
    <div class="actions">
      <div
        class="ui red left floated icon right labeled button"
        @click="remove"
        v-if="professor && uuid"
      >
        <i class="trash icon"></i>
        {{ $t("remove") }}
      </div>
      <div class="ui green icon right labeled button" @click="finished">
        <i class="check icon"></i>
        {{ $t("ok") }}
      </div>
      <div class="ui blue icon right labeled negative button">
        <i class="close icon"></i>
        {{ $t("close") }}
      </div>
    </div>
  </div>
</template>

<script>
import { local_api, error_toast } from "@/utils";
import { cloneDeep, isEmpty } from "lodash";
// import GenericModal from "@/components/GenericModal";
// import General from "./General";

export default {
  name: "ProfessorModal",
  components: {
    // "generic-modal": GenericModal,
    // General,
  },
  computed: {},
  props: { professor_in: Object },
  data() {
    return {
      uuid: undefined,
      professor: {
        name: "",
        lastname: "",
        dpi: "",
        whatsapp: "",
        tax_regime: "",
        nit: "",
        birthdate: "",
        birth_country: "",
        profession: "",
        college_number: "",
        professional_college: "",
        civil_status: "",
        email: "",
        home_address: "",
        reception_branch: "",
        teaching_branches: "",
        user_id: "",
        // setup: {
        //   description: "",
        //   general: [],
        // },
      },
      professor_configuration: {},
    };
  },
  methods: {
    finished() {
      let vm = this;
      return new Promise(function (resolve, reject) {
        let isValid = window.jQuery(vm.$refs.form).form("validate form");

        if (!isValid) reject();
        else {
          // console.log("SDFSDF");
          let pfs = cloneDeep(vm.professor);
          // let _setup = pfs.setup;

          // _setup.general = vm.$refs.general ? vm.$refs.general.getList() : [];
          // _setup.weighting = vm.$refs.weighting
          //   ? vm.$refs.weighting.getList()
          //   : [];
          // _setup.prerequisites = vm.$refs.prerequisites
          //   ? vm.$refs.prerequisites.getList()
          //   : [];

          local_api(vm, "post", "/professor/professor/do-save", {
            c: pfs,
            i: vm.uuid,
          })
            .then((product) => {
              vm.$emit("succedded", product);
              window.jQuery(vm.$refs.modal).modal("hide");
              resolve();
            })
            .catch((err) => {
              reject(err);
            });
        }
      });
    },
    destroy() {
      this.$emit("destroy");
      // this.$destroy();
    },
    show(professor) {
      let vm = this;
      if (professor) {
        vm.professor = professor.setup;
        vm.uuid = professor.uuid;

        if (vm.professor.user_id) {
          window
            .jQuery(vm.$refs.users_dropdown)
            .dropdown("set selected", vm.professor.user_id);
        }

        if (vm.professor.civil_status) {
          window
            .jQuery(vm.$refs.civil_status_dropdown)
            .dropdown("set selected", vm.professor.civil_status);
        }

        if (vm.professor.profession) {
          window
            .jQuery(vm.$refs.profession_dropdown)
            .dropdown("set selected", vm.professor.profession);
          // .dropdown({
          //   onChange(value) {
          //     vm.professor.profession = value;
          //   },
          // });
        }

        if (vm.professor.professional_college) {
          window
            .jQuery(vm.$refs.professional_college_dropdown)
            .dropdown("set selected", vm.professor.professional_college);
        }

        if (vm.professor.tax_regime) {
          window
            .jQuery(vm.$refs.tax_regime_dropdown)
            .dropdown("set selected", vm.professor.tax_regime);
        }

        if (vm.professor.reception_branch) {
          window
            .jQuery(vm.$refs.reception_branch_dropdown)
            .dropdown("set selected", vm.professor.reception_branch);
        }

        if (vm.professor.teaching_branches) {
          window
            .jQuery(vm.$refs.teaching_branches_dropdown)
            .dropdown(
              "set selected",
              vm.professor.teaching_branches.split(","),
            );
        }
      }

      window
        .jQuery(vm.$refs.modal)
        .modal({
          onHide() {
            // console.log(vm.$refs);
            window.jQuery(vm.$refs.form).form("clear");

            vm.uuid = "";
            vm.professor = {
              professor_code: "",
              name: "",
              lastname: "",
              dpi: "",
              whatsapp: "",
              tax_regime: "",
              nit: "",
              birthdate: "",
              birth_country: "",
              profession: "",
              college_number: "",
              professional_college: "",
              civil_status: "",
              email: "",
              home_address: "",
              reception_branch: "",
              teaching_branches: "",
              user_id: "",
            };
          },
        })
        .modal("show");
      // vm.$refs.general.init();
    },
    remove() {
      let vm = this;
      vm.$alertify.confirm(
        vm.$t("are you sure to remove professor?"),
        function () {
          local_api(vm, "post", "/professor/professor/do-delete", {
            u: vm.uuid,
          })
            .then(() => {
              vm.$emit("deleted");
              window.jQuery(vm.$refs.modal).modal("hide");
            })
            .catch((err) => {
              error_toast(err);
            });
        },
      );
    },
  },
  created() {},
  mounted() {
    let vm = this;

    /**
     * Users
     */
    local_api(vm, "post", "/user/do-get-simple-list")
      .then((users) => {
        // vm.users = user;

        let vls = users.map((i) => {
          return { value: i.user_id, name: i.username, stx: i };
        });
        vls.push({ value: "new", name: vm.$t("new user") });
        window
          .jQuery(vm.$refs.users_dropdown)
          .dropdown("setup menu", { values: vls })
          .dropdown({
            onChange(value) {
              if (value == "new") {
                console.log("create new user");
              } else {
                vm.professor.user_id = value;

                let trgt = vls.find((i) => i.value == value);
                vm.professor.name = trgt.stx.name;
                // let i = window.jQuery($element).parent().parent().data("i");
                // vm.professor[i].user_id = value;
              }
            },
          });
      })
      .catch((err) => {
        error_toast(err);
      });

    /**
     * Student configuration
     */
    local_api(vm, "post", "/student_configuration/do-get-configuration")
      .then((conf) => {
        if (conf && conf.std_branches) {
          // Branch
          let branches = conf.std_branches.map((i) => {
            return { value: i.branch_id, name: i.name, pfs: i };
          });
          window
            .jQuery(vm.$refs.reception_branch_dropdown)
            .dropdown("setup menu", { values: branches })
            .dropdown({
              onChange(value) {
                vm.professor.reception_branch = value;
              },
            });

          window
            .jQuery(vm.$refs.teaching_branches_dropdown)
            .dropdown("setup menu", { values: branches })
            .dropdown({
              onChange(value) {
                vm.professor.teaching_branches = value;
              },
            });
        }
      })
      .catch((err) => {
        error_toast(err);
      });

    /**
     * Module configuration
     */
    local_api(vm, "post", "/professor/setting/do-get-configuration")
      .then((conf) => {
        if (conf && conf.setup) {
          vm.professor_configuration = conf.setup;

          /**
           * Setup menus
           */

          let professions = conf.setup.professions.map((i) => {
            return { value: i.id, name: i.name, pfs: i };
          });
          window
            .jQuery(vm.$refs.profession_dropdown)
            .dropdown("setup menu", { values: professions })
            .dropdown({
              onChange(value) {
                vm.professor.profession = value;
              },
            });

          let professionalColleges = conf.setup.professional_colleges.map(
            (i) => {
              return { value: i.id, name: i.name, pfs: i };
            },
          );
          window
            .jQuery(vm.$refs.professional_college_dropdown)
            .dropdown("setup menu", { values: professionalColleges })
            .dropdown({
              onChange(value) {
                vm.professor.professional_college = value;
              },
            });

          // Tax regime
          let taxRegimes = conf.setup.tax_regimes.map((i) => {
            return { value: i.id, name: i.name, pfs: i };
          });
          window
            .jQuery(vm.$refs.tax_regime_dropdown)
            .dropdown("setup menu", { values: taxRegimes })
            .dropdown({
              onChange(value) {
                vm.professor.tax_regime = value;
              },
            });
        }
      })
      .catch((err) => {
        error_toast(err);
      });

    if (!isEmpty(vm.professor_in)) {
      vm.professor = cloneDeep(vm.professor_in);
    }

    window.jQuery(vm.$refs.civil_status_dropdown).dropdown({
      onChange(value) {
        vm.professor.civil_status = value;
      },
    });
    // local_api(this, "post", "/product/do-get-configuration")
    //   .then((conf) => {
    //     if (conf && conf.setup && conf.setup.attributes) {
    //       if (vm.product && vm.product.product_id) {
    //         vm.name = vm.product.name;
    //         vm.description = vm.product.description;
    //         vm.barcode = vm.product.barcode;
    //         vm.internal_reference = vm.product.internal_reference;
    //         vm.available_for_purchase = vm.product.available_for_purchase;
    //         vm.available_for_sale = vm.product.available_for_sale;
    //         vm.sale_price = vm.product.sale_price;
    //         vm.cost = vm.product.cost;
    //       }

    //       if (vm.product) vm.setup = _.clone(vm.product.setup);
    //       vm.setup.taxes_percentage = vm.setup.taxes_percentage || 0;

    //       vm.setup.compoundment = conf.setup.compoundment || [];
    //       vm.is_compound = vm.setup.is_compound;

    //       vm.setup.attributes = conf.setup.attributes.map((att) => {
    //         let val = "";
    //         if (vm.product && vm.product.product_id) {
    //           let trgtAttr = vm.product.setup.attributes.find(
    //             (n) => n.name == att.name,
    //           );
    //           if (trgtAttr) val = trgtAttr.value;
    //         }
    //         return {
    //           id: att.id,
    //           type: att.type,
    //           display_name: att.name,
    //           field_name: att.name.toLowerCase().replace(" ", "_"),
    //           value: val,
    //         };
    //       });

    //       if (vm.product && !vm.product.setup.variations)
    //         vm.product.setup.variations = [];
    //       vm.setup.variations = conf.setup.variations.map((att) => {
    //         let val = "";
    //         if (vm.product && vm.product.product_id) {
    //           let trgtAttr = vm.product.setup.variations.find(
    //             (n) => n.name == att.name,
    //           );
    //           if (trgtAttr) val = trgtAttr.value;
    //         }
    //         return {
    //           id: att.id,
    //           display_name: att.name,
    //           field_name: att.name.toLowerCase().replace(" ", "_"),
    //           value: val,
    //         };
    //       });

    //       window.jQuery(vm.$refs.form).form({
    //         fields: {
    //           name: ["empty"],
    //           cost: ["number"],
    //           sale_price: ["number"],
    //           taxes_percentage: ["integer[0..100]"],
    //         },
    //       });
    //     }
    //   })
    //   .catch((err) => {
    //     error_toast(err);
    //   });

    window.jQuery(vm.$refs.tabs).find(".item").tab();
  },
  updated: function () {},
};
</script>
